import { createSelector } from '@reduxjs/toolkit';
import { getRightsList } from '../../../../../redux/rights/selectors';

export const isSCCCustomer = createSelector(getRightsList, (rightsList) =>
  rightsList.some((right) => right.name === 'SCCCustomer')
);
export const isSCCService = createSelector(getRightsList, (rightsList) =>
  rightsList.some((right) => right.name === 'SCCService')
);
